import React from 'react';
import './DeleteNotificationDrawer.css';

function DeleteNotificationDrawer({ onClose, onConfirm }) {
  return (
    <div className="notif-delete-overlay">
      <div className="notif-delete-popup">
        <h3>Delete Notification?</h3>
        <p>This action will remove this notification from your list. You cannot undo this.</p>

        <div className="notif-delete-actions">
          <button className="notif-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="notif-confirm-btn" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
}

export default DeleteNotificationDrawer;
